import React, { PropsWithChildren } from "react";
//#region types
import { ReadOnlyFormControlLayoutProps } from "models/propTypes/genericFormProps";
import { FormGridLayout } from "models/propTypes/basePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "../../icon";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ReadOnlyFormControlLayout: React.FC<PropsWithChildren<ReadOnlyFormControlLayoutProps>> = (props) => {
  const { label, icon } = props;
  const formGridLayout = props.formGridLayout ?? ({ label: 3 } as FormGridLayout);

  return (
    <Grid
      container
      item
      spacing={2}
      className={cssExports.formSectionContainer}
      direction={props.inline ? "row" : "column"}
    >
      <Grid item container sm={formGridLayout.label}>
        <Grid item container direction="row" className={cssExports.formSectionHeader}>
          {icon && (
            <Grid item>
              <Icon icon={icon} />
            </Grid>
          )}
          {label && <Grid item>{LocalizationHelperInstance.getFormattedMessage(label, label)}</Grid>}
        </Grid>
      </Grid>
      <Grid container item xs spacing={1} className={cssExports.formSectionDetails}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default ReadOnlyFormControlLayout;
